<template>
  <v-app>
    <nav>
      <v-app-bar style="background-color: white;" prominent app hide-on-scroll>
        <v-img @click="volver" class="ml-6" src="@/assets/logo-sin-propiedades.jpg" style="max-width:13rem"></v-img>
        <v-spacer></v-spacer>
      </v-app-bar>
    </nav>

    <v-card align="center" height="300px" style="margin: 3rem 15%;">
      <h2 class="mt-6">Gracias por comunicarte con Alfonsina Grand Propiedades!</h2>
      <p class="mt-4">En este momento no podemos atenderte.</p>
      <p>Nuestro horario de atención es de lunes a viernes de 16 a 20 hs. y los sabados de 09 a 13 hs.</p>
      <p>Muchas Gracias!</p>
      <v-btn color="#97b699" class="btn" @click="volver">Volver</v-btn>
    </v-card>

    <div class="piePagina" align="center">
      <a href="https://www.instagram.com/invites/contact/?i=sifpxfh5bktu&utm_content=p2mr61l" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-instagram</v-icon>
        </v-btn>
      </a>
      <a href="https://www.facebook.com/AlfonsinaGrandPropiedades/" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-facebook</v-icon>
        </v-btn>
      </a>
      <v-row justify="center" class="my-1">
        <v-icon class="white--text mb-4 mr-2">mdi-email-outline</v-icon>
        <p style="color: white;">info@alfonsinagrandpropiedades.com.ar</p>
      </v-row>
      <p style="color: grey;">Terminos y condiciones | Politica de privacidad</p>
      <div style="background-color: white;">
        <v-img src="@/assets/logo1.jpg" alt="logo" style="width: 20rem; border-radius: 100%;">
        </v-img>
      </div>
    </div>
  </v-app>
</template>

<script>
  export default {
    name: 'QuienesSomos',
    methods: {
      volver () {
        this.$router.push('/')
      },
      scrollToTop () {
        window.scrollTo(0,0)
      }
    },
    mounted() {
      this.scrollToTop()
    }
  }
</script>

<style scoped>
  .btn{
    margin-top: 50px; 
    color: white;
  }
  @media screen and (max-width: 700px) {
    h2{
      font-size: medium;
    }
    p{
      font-size: small;
    }
    .btn{
      margin-top: 20px; 
    }
  }
  @media screen and (max-width: 320px) {
    .btn{
      margin-top: 6px; 
    }
  }
</style>